import * as React from 'react'
import Link from '@mulesoft/anypoint-components/lib/Link'
import Urls from '../../../Sidebar/Urls'

export type Props = {
  dashboardName: string
  dashboardNameSlug: string
}

const SuccessSaveAsMessage = (props: Props) => {
  const {dashboardName, dashboardNameSlug} = props
  return (
    <div>
      {<p><b>"{dashboardName}"</b> was successfully saved.</p>}
      {<Link to={`#${Urls.customDashboardPage}/${dashboardNameSlug}`}>View in custom dashboards</Link>}
    </div>
  )
}

export default SuccessSaveAsMessage
